import React, {Component} from "react";
import NavState from "./NavState";


class Nav extends Component {
    render() {
        return(
            <NavState />
        )
    }
} 

export default Nav;